import React, { useCallback, useContext, useEffect, useState } from "react"
import { localSettings } from "../utils/local-settings"

const SettingsContext = React.createContext(null)

const DEFAULT_SETTINGS = {
  showPrint: true,
  showOwned: true,
  showPrice: true,
  showWinRate: true,
  themeMode: "dark",
}

function startSettings() {
  const curr = localSettings.load()
  if (curr) {
    // ensure new keys are added over time
    return { ...DEFAULT_SETTINGS, ...curr }
  }
  return DEFAULT_SETTINGS
}

// settings are deliberately per-device (localStorage only, never the
// account doc) — theme and display toggles are device preferences,
// not collection data
export const SettingsProvider = ({ children }) => {
  const [state, setState] = useState(startSettings)
  useEffect(() => localSettings.store(state), [state])

  const togglePrint = useCallback(() => {
    setState((prev) => ({
      ...prev,
      showPrint: !prev.showPrint,
    }))
  }, [setState])

  const toggleOwned = useCallback(() => {
    setState((prev) => ({
      ...prev,
      showOwned: !prev.showOwned,
    }))
  }, [setState])

  const togglePrice = useCallback(() => {
    setState((prev) => ({
      ...prev,
      showPrice: !prev.showPrice,
    }))
  }, [setState])

  const toggleWinRate = useCallback(() => {
    setState((prev) => ({
      ...prev,
      showWinRate: !prev.showWinRate,
    }))
  }, [setState])

  const toggleTheme = useCallback(() => {
    setState((prev) => ({
      ...prev,
      themeMode: prev.themeMode === "dark" ? "light" : "dark",
    }))
  }, [setState])

  return (
    <SettingsContext.Provider
      value={{
        state,
        togglePrint,
        toggleOwned,
        togglePrice,
        toggleWinRate,
        toggleTheme,
      }}
    >
      {children}
    </SettingsContext.Provider>
  )
}

export const useSettings = () => {
  const val = useContext(SettingsContext)
  if (!val) {
    throw new Error("Cannot call useSettings outside context")
  }
  return val
}
